export const PLATFORM_NAME = "Facet";
export const PLATFORM_DESCRIPTION = "AI-Native POS & Clienteling for Luxury Jewelers";

export const ORDER_TYPES = {
  DINE_IN: "In-Store",
  TAKEOUT: "Pickup",
  DELIVERY: "Delivery",
  BAR_TAB: "Hold",
  DRIVE_THRU: "Curbside",
  CATERING: "Event / Private Showing",
} as const;

export const ORDER_STATUSES = {
  OPEN: "Open",
  SENT_TO_KITCHEN: "In Workshop",
  PREPARING: "Being Prepared",
  READY: "Ready for Pickup",
  SERVED: "Delivered",
  CLOSED: "Completed",
  VOIDED: "Voided",
  REFUNDED: "Refunded",
} as const;

export const TABLE_STATUSES = {
  AVAILABLE: "Available",
  OCCUPIED: "Occupied",
  RESERVED: "Reserved",
  DIRTY: "Dirty",
  BLOCKED: "Blocked",
} as const;

export const PAYMENT_METHODS = {
  CARD: "Card",
  CASH: "Cash",
  GIFT_CARD: "Gift Card",
  MOBILE_PAY: "Mobile Pay",
  SPLIT: "Split",
} as const;

export const PAYMENT_STATUSES = {
  PENDING: "Pending",
  AUTHORIZED: "Authorized",
  CAPTURED: "Captured",
  REFUNDED: "Refunded",
  VOIDED: "Voided",
  FAILED: "Failed",
} as const;

export const ITEM_TYPES = {
  FOOD: "Food",
  BEVERAGE: "Beverage",
  ALCOHOL: "Alcohol",
  MERCHANDISE: "Merchandise",
  SERVICE: "Service",
} as const;

export const KITCHEN_STATIONS = {
  GRILL: "Grill",
  FRY: "Fry",
  SAUTE: "Sauté",
  SALAD: "Salad",
  DESSERT: "Dessert",
  BEVERAGE: "Beverage",
  BAR: "Bar",
  EXPO: "Expo",
} as const;

export const SHIFT_STATUSES = {
  SCHEDULED: "Scheduled",
  CLOCKED_IN: "Clocked In",
  ON_BREAK: "On Break",
  CLOCKED_OUT: "Clocked Out",
} as const;

export const DISCOUNT_TYPES = {
  PERCENTAGE: "Percentage",
  FIXED_AMOUNT: "Fixed Amount",
  COMP: "Comp",
  EMPLOYEE: "Employee",
  HAPPY_HOUR: "Happy Hour",
} as const;

export const LOYALTY_TIERS = {
  BRONZE: "Bronze",
  SILVER: "Silver",
  GOLD: "Gold",
  PLATINUM: "Platinum",
  VIP: "VIP",
} as const;

export const RESERVATION_STATUSES = {
  CONFIRMED: "Confirmed",
  SEATED: "Seated",
  COMPLETED: "Completed",
  NO_SHOW: "No Show",
  CANCELLED: "Cancelled",
} as const;

export const SUGGESTED_TIP_PERCENTAGES = [15, 18, 20, 25] as const;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const ITEMS_PER_PAGE = 20;

export const FEATURES = {
  AI_CHAT: true,
  AI_INSIGHTS: true,
  LOYALTY_PROGRAM: true,
  ONLINE_ORDERING: false,
  DELIVERY_TRACKING: false,
  VOICE_ORDERING: false,
} as const;
